import React,{useEffect,useState} from 'react';
import ListItem from '../components/ListItem';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import {allStates,replaceAll,replaceAllByArray} from '../components/Helper';
import CommunityItem from '../components/CommunityItem';
import { BrowserRouter as Router,Routes, Route, Link,useParams } from 'react-router-dom';
import '../App.css';


const CommunityActionCenterStateAndCounty=()=>{

let { state,county } = useParams();

const [data, setData] = useState(null);
const [counties, setCounties] = useState([]);
const [foundState, setFoundState] = useState([]);


const dataFetch = async () => {

  if(typeof state === 'undefined'){
    state='';
  }  
  fetch('https://api.hudhousingnetwork.com/community-action-center?state='+state+'&county='+county)
        .then(response => response.json())
        .then((data) =>{ 
            setData(data);
          //console.log(data)
          }
        );

};

const countiesFetch = async () => {

  if(typeof state === 'undefined'){
    state='';
  }
  if(state=='')return;
  fetch('https://api.hudhousingnetwork.com/counties?state='+state)
  //fetch('https://api.hudhousingnetwork.com/counties')
        .then(response => response.json())
        .then((data) =>{ 
            setCounties(data);
          //console.log(data)
          }
        );

};





const stateFetch = async () => {

  if(typeof state === 'undefined'){
    return
  }
  fetch('https://api.hudhousingnetwork.com/get/'+state)
        .then(response => response.json())
        .then((data) =>{ 
          if(data.length>0)
          setFoundState(data[0].state);
          //console.log("R: "+data[0].state);
          }
        );

};

const toggleMe=()=>{
  if(document.querySelector('.counties').style.display=='none')
    document.querySelector('.counties').style.display='block';
  else
    document.querySelector('.counties').style.display='none';
}

useEffect(()=>{
 //console.log('Loaded!'+state+", "+county); 
 stateFetch();
 dataFetch();
 countiesFetch();

},[])

const setClick=(val)=>{
  var url='/community-action-center/';
  url=url+val;
  window.location.href=url;
  //console.log("clicked "+val.toLowerCase())
}

/*allStates.map((postData) => {
  if(postData['state_code']=='AL'){
    console.log(postData['state'])
  }
})*/
const replaceAll=(str, find, replace)=>{
  return str.replace(new RegExp(find, 'g'), replace);
}


  return (

<>
  <Header />
  <div className="content_wrapper">
    <div className="main-content">
      <div className="top-area">
        <h2 className="top-heading">Community Action Center {foundState!="" ? 'for '+foundState : ''}</h2>
        <div className="state-option">
          <div className="state-dropdown">
            <select className="statesDD" onChange={(e)=>setClick(e.target.value)} >
            {
                allStates.map((postData,index) => {            
                  var selected = postData['state_code'].toLowerCase()==state ? 'selected' : '';
                  return (<option key={index} selected={selected} value={postData['state_code'].toLowerCase()}>{postData['state']}</option>)
                
              })
            }        
            </select>
          </div>
          <div className="county-dropdown">
            <img src="/img/setting-icon.png" onClick={(e)=>toggleMe()} />
            <ul className="counties" style={{display:'none'}}>
            {
                    counties.map((postData,index) => {
                      if(postData['county']!=null){
                        let oye="/community-action-center/"+state+"/"+replaceAll(postData['county'].toLowerCase()," ","-");
                        return (<li key={index} ><a href={oye}>{postData['county']}</a></li>)
                      }
                    
                     })
            }   
            </ul>
          </div>
        </div>
        
        <p>
        Community Action Agencies (CAA) are local private and public non-profit organizations designed to improve the lives of all Americans, regardless of their circumstances. Search programs in your community using the search tool above...
        </p>
      </div>
      
      {data!=null && (
      
          data.map((item,index) => (
            <CommunityItem key={index} item={item} />
          ))

      )
    }

    {data!=null && data.length==0 && (
    <span className="sorry">Sorry we are unable to find any matching records!</span>)
    }          


    <div className="c-content">
        <p><strong>Children and Youth Services:</strong> Head Start, Literacy Programs, Dropout Prevention, After School Enrichment and Tutoring, Teen Centers, Recreation and Sports Programs, Special Supplemental Nutrition Program for Women, Infants & Children (WIC), Well-Baby Clinics, Summer Enrichment Programs, Summer Food Programs, Child Care Food Programs, Pregnancy Prevention, Character Education, Substance Abuse Education, Prevention & Counseling, Summer Youth Employment Programs, College Counseling and Placement.</p>

        <p><strong>Support The Working Poor:</strong> Child Care, Adult Education, GED Preparation, Job Training and On-The-Job Support, Job Search Assistance, Job Placement, Job Creation, Small Business Development, Loan Funds, Senior Community Service Employment, Displaced Homemaker Programs, Budget Counseling, Internet Training and Access.</p>

        <p><strong>Crisis Support:</strong> Homeless Shelters & Drop-In Centers, Utility Deposits, Eviction Prevention, Domestic Violence Programs & Shelters, Transitional Housing, Food Pantries Energy Crisis Assistance & Shelter, Emergency Food Baskets, Emergency Clothing, Supplies, and Services – including Medical & Legal Volunteer Help.</p>

        <p><strong>Elderly and Senior Support:</strong> Meals on Wheels, In-Home Care Programs, Senior Centers, Senior Day Care, Foster Grandparents, Congregate Meals, Medical Transportation, Volunteer Chore Services.</p>

        <p><strong>Family Housing and Food Assistance:</strong> Comprehensive Family Development Support, Nutrition Education, Parenting Education, Community Gardens and Canneries, Food Stamps, Health Clinics, Weatherization Assistance, Energy Assistance, Rental Assistance, Home Ownership Programs, Community Centers, Individual Development Accounts.</p>
      </div>

      <div className="apply-for"><img src="/img/curve-arrow.png" /><a href="#" style={{color:'#fff',textDecoration:'none'}}>Apply For Assistance Now</a></div>



    </div>
  <Sidebar />
  </div>
  <div className="content_wrapper">
    <div className="side-box">
      <img src="/img/apt1.png" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
    <div className="side-box">
      <img src="/img/apt2.png" alt="" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
    <div className="side-box">
      <img src="/img/apt2.png" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
  </div>
  <div className="content_wrapper">
    <div className="bottom-box">
      <div className="bottom-box-flex">
        <div className="bottom-box-image"><img src="/img/Housing-authority.png" /></div>
        <div className="bottom-box-content">
          <h2>Housing-authority</h2>
          <p>1243 West Sycamore Lafayette GA, 29010</p>
        </div>
      </div>
      <div className="bottom-box-flex2">
        <a href="" className="contact-us-link">Contact Us</a>
        <div className="bottom-box-icon">
          <img src="/img/Group238491.png" />
          <img src="/img/Group238493.png" />
        </div>
      </div>
    </div>  
  </div>








</>
  );
}

export default CommunityActionCenterStateAndCounty;
